import request from '@/utils/request'

export function storeApi(params) {
    return request({
        url: '/autoTag/store',
        method: 'post',
        data: params,
    })
}
export function getUserLogin() {
    return request({
        url: '/my/getUserLogin',
        method: 'get',
    })
}
export function getRegionStoreList(params) {
    return request({
        url: '/employeeStore/selectByLoginStore',
        method: 'get',
        params: params,
    })
}
export function saveRegionStore(params) {
    return request({
        url: '/region/store/save',
        method: 'post',
        data: params,
    })
}
